import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import { auth } from "./firebase";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/About.vue")
    },
    {
      path: "/cart",
      name: "cart",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/Cart.vue")
    },
    {
      path: "/contact",
      name: "contact",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Contact" */ "./views/Contact.vue")
    },
    // {
    //   path: '/comments',
    //   name: 'comments',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import( /* webpackChunkName: "Comments" */ './views/Comments.vue')
    // },
    {
      path: "/suits",
      name: "suits",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/Suits.vue")
    },
    {
      path: "/confirmation/:id",
      name: "confirmation",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/confirmation.vue")
    },
    {
      path: "/admin",
      name: "admin",
      meta: {
        requiresAuth: true
      },
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "SuitsAdmin" */ "./views/Admin.vue")
    },
    {
      path: "/login",
      name: "login",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Login" */ "./views/Login.vue"),
      meta: {
        forbidAuth: true
      }
    },
    {
      path: "/orders",
      name: "orders",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/Orders.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/messages",
      name: "messages",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/Messages.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/orders/:id",
      name: "details",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/Details.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/adminsuit",
      name: "adminsuit",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/adminSuits.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/adminsuit/:id",
      name: "adminsuit-single",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/adminSuit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/adminmeasurements",
      name: "adminmeasurements",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suits" */ "./views/adminMeasurements.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/measurements/:id",
      name: "measurement-details",
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(
          /* webpackChunkName: "Suits" */ "./views/measurementDetails.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/suits/:suit",
      //name:'suits',
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Suit" */ "./views/Suit.vue")
    },
    {
      path: "/sezzleconfirmationandaddtofirebaseremovefromcart/:id",
      //name:'suits',
      //name: 'suits',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "Suit" */ "./views/Sezzle.vue")
    },
    {
      path: "/stocksuits",
      component: () =>
        import("./views/StockSuits.vue")
    },
    {
      path: "/gallery",
      component: () =>
        import("./views/Gallery.vue")
    },
    {
      path: "/workwear",
      component: () =>
        import("./views/WorkWear.vue")
    },
    {
      path: "/admingallery",
      component: () =>
        import("./views/AdminGallery.vue")
    },
    {
      path: "/adminsuitdescriptions",
      component: () =>
        import("./views/AdminSuitDescriptions.vue")
    },
    {
      path: "/adminstocksuits",
      component: () =>
        import("./views/AdminStockSuits.vue")
    },
    {
      path: "/adminworkwear",
      component: () =>
        import("./views/AdminWorkWear")
    },
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const forbidAuth = to.matched.some(record => record.meta.forbidAuth);
  if (requiresAuth && !currentUser) next("login");
  else if (forbidAuth && currentUser) next("admin");
  else if (!requiresAuth && currentUser) next();
  else next();
});

export default router;
